import { Link, useLocation } from 'react-router-dom';
import { logout } from '../lib/auth';

const navItems = [
  { path: '/', label: 'Dashboard', icon: '📊' },
  { path: '/kb', label: 'Knowledge Base', icon: '📚' },
  { path: '/interview', label: 'Starter Interview', icon: '💬' },
  { path: '/pipeline', label: 'Pipeline', icon: '🔧' },
  { path: '/tracker', label: 'Tracker', icon: '📋' },
  { path: '/linkedin', label: 'LinkedIn', icon: '🔗' },
  { path: '/mentors', label: 'Mentors', icon: '👥' },
];

export default function Layout({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-xl font-bold text-blue-600">Job App</span>
          <span className="text-sm text-gray-500">AI-powered applications</span>
        </div>
        <button
          onClick={logout}
          className="text-sm text-gray-600 hover:text-gray-900 px-3 py-1 rounded border border-gray-200 hover:border-gray-400 transition-colors"
          aria-label="Sign out"
        >
          Sign out
        </button>
      </header>

      <div className="flex flex-1">
        {/* Sidebar navigation */}
        <nav className="w-56 bg-white border-r border-gray-200 p-4" aria-label="Main navigation">
          <ul className="space-y-1">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                      isActive
                        ? 'bg-blue-50 text-blue-700'
                        : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                    }`}
                    aria-current={isActive ? 'page' : undefined}
                  >
                    <span aria-hidden="true">{item.icon}</span>
                    {item.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Main content */}
        <main className="flex-1 p-6" role="main">
          {children}
        </main>
      </div>
    </div>
  );
}
